import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { Router } from '@angular/router';
import { Device } from '@deprecated/api-interfaces';
import { TranslatePipe } from '@ngx-translate/core';
import { MatchCypressPipe } from '../../pipes/match-cypress.pipe';
import { DeviceModelService, DeviceViewConfigService, PageService } from '../../services';
import { CopyContentButtonComponent } from '../copy-content-button/copy-content-button.component';
import { DeviceIconsComponent } from '../device-icons/device-icons.component';

@Component({
  selector: 'shared-device-detail-title',
  templateUrl: './device-detail-title.component.html',
  styleUrls: ['./device-detail-title.component.scss'],
  imports: [CommonModule, DeviceIconsComponent, CopyContentButtonComponent, TranslatePipe, MatchCypressPipe, FlexLayoutModule],
})
export class DeviceDetailTitleComponent implements OnDestroy, OnChanges {
  @Input() device!: Device;
  @Input() displayAssignedTo = false;

  hovered = false;

  public now!: number;
  public modelName!: string;

  constructor(
    private router: Router,
    private deviceViewConfigService: DeviceViewConfigService,
    private deviceModelService: DeviceModelService,
    private pageService: PageService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.device?.currentValue) {
      this.pageService.setTitle(this.device?.tag ?? this.device?.commNr);
      this.getDeviceModel();
    }
  }

  ngOnDestroy(): void {
    this.pageService.setTitle();
  }

  goToDevice(deviceId: string) {
    this.deviceViewConfigService.clearChartConfigurations();
    this.deviceViewConfigService.clearGaugeConfig();
    this.router.navigateByUrl(`/devices/detail/${deviceId}`, { skipLocationChange: true });
  }

  getDeviceModel(): void {
    if (this.device?.modelId) {
      this.deviceModelService.getDeviceModel(this.device.modelId).subscribe((response) => {
        this.modelName = response.name;
      });
    }
  }
}
